import React from "react";

const STATUS_STYLES = {
  ACTIVE: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  COMPLETED: "bg-blue-50 text-blue-700 ring-blue-200",
  CANCELLED: "bg-slate-100 text-slate-600 ring-slate-200",
  SCHEDULED: "bg-amber-50 text-amber-700 ring-amber-200",
  TICKET_CREATED: "bg-violet-50 text-violet-700 ring-violet-200",
  SKIPPED: "bg-slate-100 text-slate-500 ring-slate-200",
  PENDING: "bg-amber-50 text-amber-700 ring-amber-200",
  WARNING: "bg-orange-50 text-orange-700 ring-orange-200",
  ESCALATED_L1: "bg-red-50 text-red-700 ring-red-200",
  ESCALATED_L2: "bg-red-100 text-red-800 ring-red-300",
  ACKNOWLEDGED: "bg-blue-50 text-blue-700 ring-blue-200",
  RESOLVED: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  UNREAD: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  READ: "bg-slate-100 text-slate-500 ring-slate-200",
  QUEUED: "bg-amber-50 text-amber-700 ring-amber-200",
  PROCESSING: "bg-sky-50 text-sky-700 ring-sky-200",
  DIALING: "bg-indigo-50 text-indigo-700 ring-indigo-200",
  AWAITING_COMPLETION: "bg-violet-50 text-violet-700 ring-violet-200",
  RETRY_WAIT: "bg-orange-50 text-orange-700 ring-orange-200",
  FAILED: "bg-red-50 text-red-700 ring-red-200",
};

const StatusBadge = ({ status, label }) => (
  <span
    className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ring-inset ${
      STATUS_STYLES[status] || "bg-slate-100 text-slate-600 ring-slate-200"
    }`}
  >
    {label}
  </span>
);

export default StatusBadge;
